import { render, staticRenderFns } from "./FeaturedSelectedSingle.vue?vue&type=template&id=05556a14&"
import script from "./FeaturedSelectedSingle.vue?vue&type=script&lang=js&"
export * from "./FeaturedSelectedSingle.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedSelectedSingle.vue?vue&type=style&index=0&id=05556a14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports